<template>
  <PillBrowserLink
    :text="$t('copy.homePage.mainLayout.usefulLinks.links.busSchedule')"
    :url="$t('copy.homePage.mainLayout.usefulLinks.links.busSchedulePdf')"
    firebase-event-name="useful-links-shuttle-bus-schedule"
  />
</template>

<script>
import PillBrowserLink from './PillBrowserLink.vue';

export default {
  name: 'BusScheduleSection',
  components: { PillBrowserLink },
};
</script>
